<template>
	<div>
		<div class="input-group">
			<input
				v-model="search"
				type="text"
				placeholder="Pesquisar..."
				class="form-control"
			/>
			<div class="input-group-addon">
				<i class="fa fa-search"></i>
			</div>
		</div>
		<br />
		<div class="well-height well well-sm well-white no-padding">
			<table class="table table-striped no-margin table-hover">
				<tbody>
					<tr
						v-for="(exam, index) in filterExams"
						:key="index"
						class="item-exam"
						:class="getClass(exam)"
						@click="$emit('selectExam', exam.cod)"
					>
						<td>
							<input
								:checked="exam.cod == sel"
								type="radio"
								class="radioInTable"
							/>
						</td>
						<td class="cnt-exams">
							<div class="agroup-text">
								<b>{{ exam.gid }}.{{ exam.eid }}</b>
								<small>{{ exam.title }}</small>
							</div>
							<button
								@click="removeExam(exam, $event)"
								class="btn btn-danger btn-xs"
							>
								<i class="fa fa-close"></i>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
	import fxExams from './fxExams.mixin.js';
	import WBS from 'js/http';
	import toastr from 'toastr';

	export default {
		props: ['exams', 'sel'],
		mixins: [fxExams],
		data() {
			return {
				search: '',
			};
		},
		methods: {
			getClass(exam) {
				if (this.is_preenched(exam)) return 'success';
				else return 'warning';
			},
			removeExam(exam, ev) {
				ev.preventDefault();
				WBS.send('private-delete-removeExams', exam, (resp) => {
					if (resp.status == 'success') {
						const index = this.exams.findIndex(
							(item) => item.cod == exam.cod
						);
						this.exams.splice(index, 1);
						toastr.success('Exame excluído com sucesso!');
					}
				});
			},
		},
		computed: {
			filterExams() {
				if (this.search == '') return this.exams;
				return this.exams.filter((item) => {
					let lineText =
						`${item.gid}.${item.eid} ${item.title}`.toUpperCase();
					if (lineText.indexOf(this.search.toUpperCase()) != -1)
						return item;
				});
			},
		},
	};
</script>
<style scoped>
	.cnt-exams {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.well-height {
		height: 300px;
		overflow: auto;
	}
	.radioInTable {
		width: 17px;
		height: 26px;
		margin: 0 auto 0px auto;
		display: block;
	}
	.well-white {
		background-color: #fff;
	}
	.item-exam {
		cursor: pointer;
	}
	.item-exam b {
		display: block;
		margin: -4px 0;
	}
	.item-exam small {
		display: block;
		margin: 0 0 -2px 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/sd2000/solicitacoes/mdExams/gridExams.vue